import { AiPromptSummaryResponse, UserResponse } from '@ydistri/api-sdk';

export const matchesTitle = (prompt: AiPromptSummaryResponse, search: string): boolean => {
  const needle = search.trim().toLowerCase();
  return needle === '' || prompt.title.toLowerCase().includes(needle);
};

export const authorName = (author: Pick<UserResponse, 'fullName'> | null | undefined): string =>
  author?.fullName ?? '-';
